import { render, staticRenderFns } from "./VerifyCodeFTL.vue?vue&type=template&id=08827674&scoped=true&"
import script from "./VerifyCodeFTL.vue?vue&type=script&lang=js&"
export * from "./VerifyCodeFTL.vue?vue&type=script&lang=js&"
import style0 from "./VerifyCodeFTL.vue?vue&type=style&index=0&id=08827674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08827674",
  null
  
)

export default component.exports